module.exports = __webpack_public_path__ + "img/account-registered.c69b053f.png";